import { useState } from 'react';
import { Overlay } from '@/components/ui/Overlay/Overlay';
import { Icon } from '@/components/ui/Icon/Icon';
import { nb } from '@/i18n/nb';
import { GenereltVedlikehold } from './GenereltVedlikehold';
import { DugnadsOppgaver } from './DugnadsOppgaver';
import s from './Vedlikehold.module.css';

type Subcard = 'generelt' | 'dugnad';

const SUBCARDS: Array<{ id: Subcard; title: string; desc: string }> = [
  {
    id: 'generelt',
    title: nb.vedlikehold.subcards.generelt,
    desc: nb.vedlikehold.subcards.generelDesc,
  },
  { id: 'dugnad', title: nb.vedlikehold.subcards.dugnad, desc: nb.vedlikehold.subcards.dugnadDesc },
];

/*
 * Vedlikehold — a nested module. The overlay opens to two sub-cards (the same
 * nested pattern as Hytteregler og -rutiner, per ADR-0028): Generelt vedlikehold
 * (the maintenance knowledge list, kategori-grouped) and Dugnadsoppgaver (the
 * communal-work task flat list with status + assignee).
 *
 * The overlay title + the shared <Overlay onBack> track the level, so the back
 * button / Esc step sub-card → overview → landing. Renders its own <Overlay> to
 * own the sub-state — identical structure to Hytteregler so the navigation feels
 * the same across the two nested modules.
 */
export function Vedlikehold({ onClose }: { onClose: () => void }) {
  const [sub, setSub] = useState<Subcard | null>(null);
  const active = sub !== null ? SUBCARDS.find((c) => c.id === sub)! : null;

  return (
    <Overlay
      title={active ? active.title : nb.vedlikehold.title}
      onClose={onClose}
      onBack={active ? () => setSub(null) : undefined}
    >
      {active ? (
        active.id === 'generelt' ? (
          <GenereltVedlikehold />
        ) : (
          <DugnadsOppgaver />
        )
      ) : (
        <div className={s.grid}>
          {SUBCARDS.map((card) => (
            <button
              key={card.id}
              type="button"
              className={s.subcard}
              onClick={() => setSub(card.id)}
            >
              <Icon name="list" size={26} className={s.subcardIcon} />
              <div className={s.subcardLabels}>
                <span className={s.subcardLabel}>{card.title}</span>
                <span className={s.subcardDesc}>{card.desc}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </Overlay>
  );
}
